import './../css/base.css';
import './../css/custom.css';
import './../css/profile.css';

import Bio from './../images/bio.JPG';
import ani0 from './../images/ani-cameraman.gif';
import ani1 from './../images/ani-house.gif';
import ani2 from './../images/ani-peppers.gif';
import sakura from './../images/sakura.webp';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink, faBuildingColumns, faEnvelope, faUpRightFromSquare} from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { useEffect } from "react";
import ImageWithLoader from './ImageWithLoader.js';

library.add(faLink, faBuildingColumns, faEnvelope, faUpRightFromSquare);

const Career = ({yearFrom, yearTo, children}) => {
    return (
        <div className="career-box">
            <div className="year font-s dflex dflexac gap-m">
                <span>{yearFrom} - {yearTo}</span>
            </div>
            <span className="career-content">{children}</span>
        </div>
    )
}

const GnF = ({yearFrom, yearTo, children, muted}) => {
    return (
        <div className="dflex dflexac gap-m GnF-box">
            <span className="year">{yearFrom} {yearTo && <span className="font-ms"> - {yearTo}</span>}</span>
            <span className="content">{children}</span>
        </div>
    )
}

const KeywordList = ({ items }) => {
    return (
      <div className="dflex dflexac gap-ml kw-box dflex-wrap">
        {items.map((text, i) => (
          <span className="dflex dflexac gap-ml kw" key={i}>
            <a
              href={`https://www.google.com/search?q=${encodeURIComponent(text)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="kw-link"
            >
              #{text}
            </a>
          </span>
        ))}
      </div>
    );
};
  
const Profile = () => {
    useEffect(() => {
        document.title = "Yodai Suzuki / 鈴木 陽大";
      }, []);

    const { t } = useTranslation("profile");
    const edu = t("edu", { returnObjects: true });
    const edu_rev = [...edu].reverse();
    const researchAreas = t("research-area", { returnObjects: true });
    const GnF_dt = t("GnF", { returnObjects: true });
    const Scholarship_dt = t("Scholarship", { returnObjects: true });
    const GnF_rev = [...GnF_dt].reverse();
    const Scholarship_rev = [...Scholarship_dt].reverse();
    const Awards_dt = t("Awards", { returnObjects: true });
    const Awards_rev = [...Awards_dt].reverse();
    const Service_dt = t("Service", { returnObjects: true });
    const Service_rev = [...Service_dt].reverse();
    const Others_dt = t("Others", { returnObjects: true });
    const Others_rev = [...Others_dt].reverse();
    
    return (
    <div className="window-wrapper">
        <div className="content-wrapper">
            <div className = "prof-box">
                <ImageWithLoader src={Bio} className="img-fluid bio" alt=""/>
                <div className="prof-inner-box">
                    <h1 id="title">{t("name-main")} 
                        <span className="prof-name-sub">{t("name-sub")}</span>
                    </h1>
                    <div className="prof-box-line"></div>
                    <div className="dflex dflexac gap-m">
                        <FontAwesomeIcon icon="envelope" className="fa gray"/>
                        <span>suzuki.y.bd8c@m.isct.ac.jp</span>
                    </div>
                    <div className="dflex dflexac gap-m">
                        <a className="dflex dflexac gap-m" href="https://scholar.google.com/citations?hl=ja&user=yq3ujBoAAAAJ" target="_blank" rel="noopener noreferrer">
                            <span>Google Scholar </span>
                            <FontAwesomeIcon icon="up-right-from-square" className="fa gray font-s"/>
                        </a>
                    / 
                        <a className="dflex dflexac gap-m" href="https://www.linkedin.com/in/yodai-suzuki-80b039304/" target="_blank" rel="noopener noreferrer">
                            <span>LinkedIn</span>
                            <FontAwesomeIcon icon="up-right-from-square" className="fa gray font-s"/>
                        </a>
                    </div>
                    <div className="prof-affiliation-box dflexc gap-m flex-wrap">
                        <span className="dflex dflexac gap-m flex-wrap">
                            <FontAwesomeIcon icon="building-columns" className="fa gray"/>
                            <span>{t("affiliation-0")}</span>
                            <span>{t("affiliation-1")}</span>
                            <span>{t("affiliation-2")}</span>
                        </span>
                        <span className="dflex dflexac gap-m flex-wrap">
                            <span>{t("affiliation-3")} </span>
                            <a className="dflex dflexac" href="https://www.mdi.c.titech.ac.jp/home" target="_blank" rel="noopener noreferrer">
                                <span>{t("affiliation-4")}</span>
                                <FontAwesomeIcon icon="up-right-from-square" className="fa gray font-s"/>
                            </a>
                        </span>
                    </div>
                </div>
            </div>
            <div className="dflexc">
                <div className="dflex dflexac gap-l mob-c mob-flexs">
                    <div className="dflexc dflexas in-flex-spacer">
                        <h2 className="dflex dflexae gap-l">#
                            <span>{t("h-edu")}</span>
                            <span className="h2-sub">{t("h-edu_sub")}</span>
                        </h2>  
                        <div className="dflex dflexac gap-m posrel career-wrapper-outer">
                            <div className="career-wrapper-inner dflexc">
                                {edu_rev.map((c, i) => (
                                    <Career key={i} yearFrom={c.yearFrom} yearTo = {c.yearTo}><div>{c.name}<span className="font-s">{c.formerly}</span></div><div  className="dflex dflexac gap-m mob-flexs"><span className="font-ms slash">/</span> <span className="font-ms">{c.affiliation}</span></div></Career>
                                ))}
                            </div>
                        </div>
                    </div>
                    <ImageWithLoader src={sakura} className="img-fluid sakura" alt=""/>
                </div>
                <div className="dflexc dflexas">
                    <h2 className="dflex dflexae gap-l">#
                        <span>{t("h-research")}</span>
                        <span className="h2-sub">{t("h-research_sub")}</span>
                    </h2>  
                    <div className="text-wrap text-start dflex gap-m dflexac mob-c research-wrapper">
                        <div className="area-kws">
                        {researchAreas.map((group, idx) => (
                            <KeywordList key={idx} items={group} />
                        ))}
                        </div>
                        <div className="dflex dflexac gap-m dflex-wrap">
                            <ImageWithLoader src={ani0} className="img-fluid ani" alt=""/>
                            <ImageWithLoader src={ani1} className="img-fluid ani" alt=""/>
                            <ImageWithLoader src={ani2} className="img-fluid ani" alt=""/>
                        </div>
                    </div>
                </div>
            </div>
            <h2 className="dflex dflexae gap-l">#
                <span>{t("h-GnF")}</span>
                <span className="h2-sub">{t("h-GnF_sub")}</span>
            </h2>  
            <div className="text-wrap text-start GnF-wrapper">
                {GnF_rev.map((c, i) => (
                    <GnF key={i} yearFrom={c.yearFrom} yearTo = {c.yearTo}>{c.text}</GnF>
                ))}
            </div>
            <h2 className="dflex dflexae gap-l">#
                <span>{t("h-Scholarship")}</span>
                <span className="h2-sub">{t("h-Scholarship_sub")}</span>
            </h2>  
            <div className="text-wrap text-start GnF-wrapper">
                {Scholarship_rev.map((c, i) => (
                    <GnF key={i} yearFrom={c.yearFrom} yearTo = {c.yearTo}>{c.text}</GnF>
                ))}
            </div>
            <h2 className="dflex dflexae gap-l">#
                <span>{t("h-awards")}</span>
                <span className="h2-sub">{t("h-awards_sub")}</span>
            </h2>  
            <div className="text-wrap text-start GnF-wrapper">
                {Awards_rev.map((c, i) => (
                    <GnF key={i} yearFrom={c.yearFrom} yearTo={c.yearTo}>{c.text}</GnF>
                ))}
            </div>
            <h2 className="dflex dflexae gap-l">#
                <span>{t("h-service")}</span>
                <span className="h2-sub">{t("h-service_sub")}</span>
            </h2>  
            <div className="text-wrap text-start GnF-wrapper">
                {Service_rev.map((c, i) => (
                    <GnF key={i} yearFrom={c.yearFrom} yearTo={c.yearTo}>{c.text}</GnF>
                ))}
            </div>
            <h2 className="dflex dflexae gap-l">#
                <span>{t("h-others")}</span>
                <span className="h2-sub">{t("h-others_sub")}</span>
            </h2>  
            <div className="text-wrap text-start GnF-wrapper">
                {Others_rev.map((c, i) => (
                    <GnF key={i} yearFrom={c.yearFrom} yearTo={c.yearTo}>{c.text}</GnF>
                ))}
            </div>
            <div className="spacer-mid posrel">
            </div>
        </div>
    </div>
  );
};

export default Profile;